var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pv-tooltip",class:{
    'is-left': _vm.position === 'left',
    'is-top': _vm.position === 'top',
    'is-right': _vm.position === 'right',
    'is-bottom': _vm.position === 'bottom',
    'is-top-left': _vm.position === 'top-left',
    'is-top-right': _vm.position === 'top-right',
    'is-bottom': _vm.position === 'bottom',
    'is-bottom-left': _vm.position === 'bottom-left',
    'is-bottom-right': _vm.position === 'bottom-right',
    'has-much-text': _vm.hasMuchText
  },on:{"mouseenter":_vm.onMouseEnter}},[_c('span',{staticClass:"pv-tooltip_container"},[_vm._t("default")],2),_c('span',{ref:"messageContainer",staticClass:"pv-tooltip_message_container"},[_c('span',{ref:"message",staticClass:"pv-tooltip_message"},[_vm._t("message",[_vm._v(_vm._s(_vm.message))])],2),_c('div',{staticClass:"pv-tooltip_position-indicator"})])])}
var staticRenderFns = []

export { render, staticRenderFns }